import A1 from './screens/A1'

const knowledgeSourcesScreen =
  'https://cdn.magicpatterns.com/uploads/53BfSyqMSUNTwvnuh3MtiM/image.png'

const teacherHubScreen =
  'https://cdn.magicpatterns.com/uploads/5aPPpEqK2JWWkF7UyUoTDs/image.png'

const addUpdateScreen =
  'https://cdn.magicpatterns.com/uploads/5PoCxttPDJ9ch528cY3Ur9/image.png'

const coachingConsultationScreen =
  'https://cdn.magicpatterns.com/uploads/gYHjUnz1RbxRw5iy4RyPb7/image.png'

const growthRecordScreen =
  'https://cdn.magicpatterns.com/uploads/hRcFC9QBnWv31CZjf2DMQh/image.png'

const leaderSignalsScreen =
  'https://cdn.magicpatterns.com/uploads/9K2paYo6rxgUZs9Xc6nCrx/image.png'

const leaderTodayScreen =
  'https://cdn.magicpatterns.com/uploads/dyWzQefEDUNWqqCzCqWMEQ/image.png'

export const productScreens: Record<string, { src: string; alt: string }> = {
  A1: {
    src: A1,
    alt: 'Nisa Coach Hub with Ask Nisa and connected teacher coaching records',
  },
  A2: {
    src: addUpdateScreen,
    alt: 'Add update note in a Nisa teacher profile showing Nisa structuring observation notes and connecting the update to active coaching goals',
  },
  A3: {
    src: coachingConsultationScreen,
    alt: 'Coach consulting with Ask Nisa to synthesize a teacher profile, goals, and coaching touchpoints into a weekly progress summary for school leaders',
  },
  A4: {
    src: growthRecordScreen,
    alt: 'Teacher profile in Nisa showing the What Nisa knows summary and a Growth Record of observations and classroom visits',
  },
  A5: {
    src: knowledgeSourcesScreen,
    alt: 'Nisa knowledge sources showing the Nisa Core collection of teaching, coaching, and instructional leadership guidance alongside a school’s own uploaded sources',
  },
  A6: {
    src: teacherHubScreen,
    alt: 'Nisa Teacher Hub showing a teacher Growth Record and coaching history with Ask Nisa open for guided reflection on a student talk-time pattern',
  },
  LEADER_SIGNALS: {
    src: leaderSignalsScreen,
    alt: 'Nisa Leader Hub showing latest coaching signals across schools, including bright spots, support needs, and coaching activity trends',
  },
  LEADER_TODAY: {
    src: leaderTodayScreen,
    alt: 'Nisa Leader Hub Today page showing Ask Nisa and an overview of the latest coaching signals across schools and projects',
  },
}
